'use client';
import React from 'react';
import { useTranslations } from 'next-intl';

import type {
  RestaurantEvent,
  Store,
} from '@/lib/types/customer/restaurant/StoreProfile';
import EventCard from '@/components/store/EventCard';
import { ActiveSubscription } from '@/lib/types/customer/restaurant/ActiveSubscription';
import { isBasicSubscriber } from '@/lib/helpers/functions';
import If from '@ui/If';
import NotAvailableCard from '@/shared/NotAvailableCard';

type Props = {
  store: Store;
  events: RestaurantEvent[];
  activeSubscription: ActiveSubscription;
};

export default function Events({ events, activeSubscription, store }: Props) {
  const t = useTranslations('storefront.store_profile');
  if (!store.features.crud_on_events) {
    return <></>;
  }
  if (!events || events.length <= 0 || isBasicSubscriber(activeSubscription)) {
    return <></>;
  }
  return (
    <section className="events-section">
      <div className="upcoming-events">
        <div className="section-heading mb-6">
          <h3 className="text-h3 font-[900] leading-[140%] text-title">
            {t('upcoming_events')}
          </h3>
        </div>
        <If
          condition={events && events.length > 0}
          fallback={<NotAvailableCard />}
        >
          <div className="event-list space-y-5">
            {events.map((item) => {
              return (
                <React.Fragment key={item.id}>
                  <EventCard event={item} />
                </React.Fragment>
              );
            })}
          </div>
        </If>
      </div>
    </section>
  );
}
